export default __webpack_public_path__ + "assets/webgl/disconnected.218c8c2d.png";